/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.getRepos'

export { $nsid }

/** Get details about some repositories. */
const main = l.query(
  $nsid,
  l.params({ dids: l.array(l.string({ format: 'did' }), { maxLength: 100 }) }),
  l.jsonPayload({
    repos: l.array(
      l.typedUnion(
        [
          l.typedRef<ModerationDefs.RepoViewDetail>(
            (() => ModerationDefs.repoViewDetail) as any,
          ),
          l.typedRef<ModerationDefs.RepoViewNotFound>(
            (() => ModerationDefs.repoViewNotFound) as any,
          ),
        ],
        false,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
